import React, { useEffect } from "react";
import "@/App.css";
import "@/themes/cosmic-night.css";
import { BrowserRouter, Routes, Route, useLocation, Navigate } from "react-router-dom";
import { Toaster, toast } from "sonner";
import { HelmetProvider } from "react-helmet-async";
import api from "@/lib/api";
import { AuthProvider } from "@/context/AuthContext";
import { CurrencyProvider } from "@/context/CurrencyContext";
import { ThemeProvider } from "@/context/ThemeContext";
import CosmicNightBackdrop from "@/components/CosmicNightBackdrop";
import { OngoingChatProvider } from "@/context/OngoingChatContext";
import LandingPage from "@/pages/LandingPage";
import AppHomePage from "@/pages/AppHomePage";
import AstrologersPage from "@/pages/AstrologersPage";
import AstrologerDetailPage from "@/pages/AstrologerDetailPage";
import ChatPage from "@/pages/ChatPage";
import CustomerDashboardPage from "@/pages/CustomerDashboardPage";
import AstrologerLoginPage from "@/pages/AstrologerLoginPage";
import LoginPage from "@/pages/LoginPage";
import StoreIndexPage from "@/pages/StoreIndexPage";
import StoreProductPage from "@/pages/StoreProductPage";
import AstrologerRegisterPage from "@/pages/AstrologerRegisterPage";
import AstrologerDashboardPage from "@/pages/AstrologerDashboardPage";
import AuthCallback from "@/pages/AuthCallback";
import useSignupConversion from "@/hooks/useSignupConversion";
import KundaliCalculatorPage from "@/pages/KundaliCalculatorPage";
import CompatibilityPage from "@/pages/CompatibilityPage";
import NameNumerologyPage from "@/pages/NameNumerologyPage";
import RahuPlacementPage from "@/pages/RahuPlacementPage";
import MyChatsPage from "@/pages/MyChatsPage";
import DailyHoroscopePage from "@/pages/DailyHoroscopePage";
import NakshatraAnalysisPage from "@/pages/NakshatraAnalysisPage";
import PushkarPage from "@/pages/PushkarPage";
import ChakraAnalysisPage from "@/pages/ChakraAnalysisPage";
import BhriguBinduPage from "@/pages/BhriguBinduPage";
import KPAstrologyPage from "@/pages/KPAstrologyPage";
import LotteryIndicatorPage from "@/pages/LotteryIndicatorPage";
import DemographicsAnalyticsPage from "@/pages/DemographicsAnalyticsPage";
import PlanetEffectsPage from "@/pages/PlanetEffectsPage";
import NavamsaPage from "@/pages/NavamsaPage";
import ReportsPage from "@/pages/ReportsPage";
import DeepNumerologyPage from "@/pages/DeepNumerologyPage";
import VarshaphalPage from "@/pages/VarshaphalPage";
import PastLifePage from "@/pages/PastLifePage";
import AdminAnalyticsPage from "@/pages/AdminAnalyticsPage";
import AdminRevenuePage from "@/pages/AdminRevenuePage";
import AdminRagaRemediesPage from "@/pages/AdminRagaRemediesPage";
import AdminActiveOnlinePage from "@/pages/AdminActiveOnlinePage";
import AdminAstrologersPage from "@/pages/AdminAstrologersPage";
import AdminRecentRatingsPage from "@/pages/AdminRecentRatingsPage";
import AdminCustomerLookupPage from "@/pages/AdminCustomerLookupPage";
import AdminCurrentVipsPage from "@/pages/AdminCurrentVipsPage";
import AdminLotteryDatesPage from "@/pages/AdminLotteryDatesPage";
import AdminKarmaVipakaPage from "@/pages/AdminKarmaVipakaPage";
import CareerRemedyPage from "@/pages/CareerRemedyPage";
import BhagyaRemedyPage from "@/pages/BhagyaRemedyPage";
import D10RemedyPage from "@/pages/D10RemedyPage";
import AdminWalletDeductionsPage from "@/pages/AdminWalletDeductionsPage";
import WalletTopUpAmountPage from "@/pages/WalletTopUpAmountPage";
import WalletTopUpPayPage from "@/pages/WalletTopUpPayPage";
import AdminLLMUsagePage from "@/pages/AdminLLMUsagePage";
import AdminWhalesPage from "@/pages/AdminWhalesPage";
import AdminCelebrityCachePage from "@/pages/AdminCelebrityCachePage";
import AdminAddCelebrityPage from "@/pages/AdminAddCelebrityPage";
import AdminDeleteCelebrityPage from "@/pages/AdminDeleteCelebrityPage";
import CelebrityLookalikePage from "@/pages/CelebrityLookalikePage";
import CelebrityPatternRecognizerPage from "@/pages/CelebrityPatternRecognizerPage";
import BabyMuhuratPage from "@/pages/BabyMuhuratPage";
import TwentyYearPredictionPage from "@/pages/TwentyYearPredictionPage";
import AstroVisualizationPage from "@/pages/AstroVisualizationPage";
import VisualiseIntroPage from "@/pages/VisualiseIntroPage";
import PersonalZoomMeetingPage from "@/pages/PersonalZoomMeetingPage";
import DoshasPage from "@/pages/DoshasPage";
import RajaYogasPage from "@/pages/RajaYogasPage";
import DivisionalChartsPage from "@/pages/DivisionalChartsPage";
import MuhuratFinderPage from "@/pages/MuhuratFinderPage";
import IshtaDevataPage from "@/pages/IshtaDevataPage";
import AshtakavargaPage from "@/pages/AshtakavargaPage";
import RashiTulyaNavamsaPage from "@/pages/RashiTulyaNavamsaPage";
import KalachakraDashaPage from "@/pages/KalachakraDashaPage";
import DashaCalculatorPage from "@/pages/DashaCalculatorPage";
import SaptavimshamshaPage from "@/pages/SaptavimshamshaPage";
import RudramshaPage from "@/pages/RudramshaPage";
import WealthHoraPage from "@/pages/WealthHoraPage";
import MarriageMuhuratPage from "@/pages/MarriageMuhuratPage";
import AllToolsPage from "@/pages/AllToolsPage";
import AdminAstrologerApplicationsPage from "@/pages/AdminAstrologerApplicationsPage";
import CelebritiesPage from "@/pages/CelebritiesPage";
import CelebrityDetailPage from "@/pages/CelebrityDetailPage";
import AstroGPSPage from "@/pages/AstroGPSPage";
import LifeReplayPage from "@/pages/LifeReplayPage";
import WealthProgrammingPage from "@/pages/WealthProgrammingPage";
import OnboardingGate from "@/components/OnboardingGate";
import OngoingChatDock from "@/components/OngoingChatDock";
import GlobalAstrologerRing from "@/components/GlobalAstrologerRing";
import PushPermissionModal from "@/components/PushPermissionModal";
import AdminAdsPerformancePage from "@/pages/AdminAdsPerformancePage";
import AdminGlobalMarketsPage from "@/pages/AdminGlobalMarketsPage";
import ForumPage, { ForumPostDetail } from "@/pages/ForumPage";
import CommunityHomePage from "@/pages/CommunityHomePage";
import AdminForumPage from "@/pages/AdminForumPage";
import AdminLibraryPage from "@/pages/AdminLibraryPage";
import NadiAstrologyPage from "@/pages/NadiAstrologyPage";
import GoogleAuthCallback from "@/pages/GoogleAuthCallback";
import PrivacyPolicyPage from "@/pages/PrivacyPolicyPage";
import TermsOfServicePage from "@/pages/TermsOfServicePage";
import RefundPolicyPage from "@/pages/RefundPolicyPage";
import ShippingPolicyPage from "@/pages/ShippingPolicyPage";
import AdminUsersPage from "@/pages/AdminUsersPage";
import AdminGrantUnlockPage from "@/pages/AdminGrantUnlockPage";
import AdminAstrologerVisibilityPage from "@/pages/AdminAstrologerVisibilityPage";
import AdminPromosPage from "@/pages/AdminPromosPage";
import AdminAccountDeletePage from "@/pages/AdminAccountDeletePage";
import AdminStoreOrdersPage from "@/pages/AdminStoreOrdersPage";
import AdminVoiceCallsPage from "@/pages/AdminVoiceCallsPage";
import AccountDeletionPage from "@/pages/AccountDeletionPage";
import AdminPushPage from "@/pages/AdminPushPage";
import AdminPdfCachePurgePage from "@/pages/AdminPdfCachePurgePage";
import AppShowcasePage from "@/pages/AppShowcasePage";
import AdminThemesPage from "@/pages/AdminThemesPage";
import AdminWithdrawalsPage from "@/pages/AdminWithdrawalsPage";
import CourseBookingPage from "@/pages/CourseBookingPage";
import AdminRecentPurchasesPage from "@/pages/AdminRecentPurchasesPage";
import AdminRecentTopupsPage from "@/pages/AdminRecentTopupsPage";
import BlogListPage from "@/pages/BlogListPage";
import BlogPostPage from "@/pages/BlogPostPage";
import AdminBlogPage from "@/pages/AdminBlogPage";
import AdminAutoBlogPage from "@/pages/AdminAutoBlogPage";
import ContactUsPage from "@/pages/ContactUsPage";
import AdminContactQueriesPage from "@/pages/AdminContactQueriesPage";
import AdminSeedReviewsPage from "@/pages/AdminSeedReviewsPage";
import { trackLanding } from "@/lib/adAttribution";
import { initCapacitorAuthBridge } from "@/lib/capacitorAuth";
import { initCapacitorPush } from "@/lib/capacitorPush";
import GlobalMobileTabBar from "@/components/GlobalMobileTabBar";

const TOAST_OPTIONS = {
  style: {
    background: "#FFFFFF",
    color: "#1A1410",
    border: "1px solid rgba(26, 20, 16, 0.08)",
  },
};

// iOS notch / status-bar safe-area offset for top toasts. Without this the
// toast is clipped by the iPhone Dynamic Island / status-bar because
// Capacitor's WebView starts at y=0 (below the physical status bar) but
// the OS still paints the clock/battery over the top of the WebView.
// Web browsers don't have this problem (they anchor below the address bar
// which already respects safe-area) — but the extra padding is harmless
// there too. 12px extra keeps a comfortable air gap under the notch.
const TOAST_OFFSET = "calc(env(safe-area-inset-top, 0px) + 12px)";

function AppRouter() {
  const location = useLocation();

  // Capacitor: process any deep-link Google-OAuth session token left in
  // the URL fragment, and subscribe to App Links re-entries. No-op on Web.
  // Also bootstraps the FCM push registration for the Android app — the
  // web version continues to use VAPID Web Push via `usePushNotifications`.
  useEffect(() => {
    initCapacitorAuthBridge();
    initCapacitorPush();
  }, []);

  // Ping the visitor-tracker on every route change. The backend
  // upserts a long-lived visitor_id cookie so unique-visitor counts
  // stay accurate across sessions.
  useEffect(() => {
    api.post("/track/visit").catch(() => {});
  }, [location.pathname]);

  // Capture Google Ads gclid / UTM params into our first-party
  // ad_landings table so super-admin can see the full ad→signup→chat→paid
  // funnel. Runs once per app boot and again whenever a gclid/utm shows
  // up in the URL.
  useEffect(() => {
    trackLanding();
  }, [location.search]);

  // Scroll to top whenever the route changes (unless the URL has a #hash
  // anchor — those should keep their in-page jump behaviour).
  useEffect(() => {
    if (!location.hash) {
      window.scrollTo({ top: 0, left: 0, behavior: "instant" });
    }
  }, [location.pathname]);

  // Fire a fresh GA4 / Google Ads pageview on every SPA route change.
  // The base `gtag('config', ...)` in index.html only counts the initial
  // load; without this, GA would record only one pageview per session.
  useEffect(() => {
    if (typeof window === "undefined" || typeof window.gtag !== "function") return;
    const path = location.pathname + location.search;
    window.gtag("event", "page_view", {
      page_path: path,
      page_location: window.location.origin + path,
      page_title: document.title,
    });
  }, [location.pathname, location.search]);

  // Fire a Google Ads sign-up conversion whenever any page is opened
  // with `?signup=success` (stamped by AuthCallback for new users).
  useSignupConversion();

  // Surface OAuth callback failures via toast, then strip the query param
  // from the URL so the toast doesn't fire again on subsequent renders.
  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const err = params.get("auth_error");
    if (!err) return;
    const messages = {
      invalid_state: "Your sign-in link expired. Please try signing in again.",
      missing_code_or_state: "Sign-in link was incomplete. Please try again.",
      oauth_timeout: "Sign-in is taking longer than expected. Please retry.",
      oauth_not_configured: "Google sign-in is temporarily unavailable.",
      token_exchange_failed: "Could not reach Google. Please retry.",
      google_rejected_code: "Google declined the sign-in. Please retry.",
      no_access_token: "Google did not return a token. Please retry.",
      userinfo_failed: "Could not fetch your Google profile. Please retry.",
      userinfo_rejected: "Google declined your profile request. Please retry.",
      no_email: "No email was provided by Google. Please retry.",
      access_denied: "You declined the Google permissions. Please retry.",
    };
    toast.error(messages[err] || "Sign-in failed. Please try again.", {
      duration: 6000,
    });
    params.delete("auth_error");
    const clean = location.pathname + (params.toString() ? `?${params.toString()}` : "") + (location.hash || "");
    window.history.replaceState({}, "", clean);
  }, [location.search, location.pathname, location.hash]);

  if (location.hash?.includes("session_id=")) return <AuthCallback />;
  return (
    <>
      <Routes>
        <Route
          path="/"
          element={
            // v2.0.17 — inside the Capacitor Android app, route "/" to
            // the mobile-first AppHomePage (3 hero tiles + rotating
            // marketing banner + 6 astrologers). The website home
            // (LandingPage) stays intact for browser visitors.
            typeof window !== "undefined" &&
            window.Capacitor &&
            window.Capacitor.isNativePlatform &&
            window.Capacitor.isNativePlatform()
              ? <AppHomePage />
              : <LandingPage />
          }
        />
        <Route path="/astrologers" element={<AstrologersPage />} />
        <Route path="/astrologers/:id" element={<AstrologerDetailPage />} />
        <Route path="/chat/:chatId" element={<ChatPage />} />
        <Route path="/dashboard" element={<CustomerDashboardPage />} />
        <Route path="/astrologer/login" element={<AstrologerLoginPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/sign-in" element={<Navigate to="/login" replace />} />
        <Route path="/signin" element={<Navigate to="/login" replace />} />
        <Route path="/store" element={<StoreIndexPage />} />
        <Route path="/store/:slug" element={<StoreProductPage />} />
        <Route path="/astrologer/register" element={<AstrologerRegisterPage />} />
        <Route path="/astrologer/dashboard" element={<AstrologerDashboardPage />} />
        <Route path="/kundali-calculator" element={<KundaliCalculatorPage />} />
        <Route path="/compatibility" element={<CompatibilityPage />} />
        <Route path="/name-numerology" element={<NameNumerologyPage />} />
        <Route path="/rahu-placement" element={<RahuPlacementPage />} />
        <Route path="/chats" element={<MyChatsPage />} />
        <Route path="/horoscope" element={<DailyHoroscopePage />} />
        <Route path="/nakshatra" element={<NakshatraAnalysisPage />} />
        <Route path="/tools/pushkar" element={<PushkarPage />} />
        <Route path="/chakras" element={<ChakraAnalysisPage />} />
        <Route path="/bhrigu-bindu" element={<BhriguBinduPage />} />
        <Route path="/kp-astrology" element={<KPAstrologyPage />} />
        <Route path="/admin/lottery-indicator" element={<LotteryIndicatorPage />} />
        <Route path="/admin/demographics" element={<DemographicsAnalyticsPage />} />
        <Route path="/planet-effects" element={<PlanetEffectsPage />} />
        <Route path="/navamsa" element={<NavamsaPage />} />
        <Route path="/reports" element={<ReportsPage />} />
        <Route path="/numerology-deep" element={<DeepNumerologyPage />} />
        <Route path="/varshaphal" element={<VarshaphalPage />} />
        <Route path="/past-life" element={<PastLifePage />} />
        <Route path="/admin/analytics" element={<AdminAnalyticsPage />} />
        <Route path="/admin/revenue" element={<AdminRevenuePage />} />
        <Route path="/admin/raga-remedies" element={<AdminRagaRemediesPage />} />
        <Route path="/admin/active-online" element={<AdminActiveOnlinePage />} />
        <Route path="/doshas" element={<DoshasPage />} />
        <Route path="/raja-yogas" element={<RajaYogasPage />} />
        <Route path="/divisional-charts" element={<DivisionalChartsPage />} />
        <Route path="/muhurat" element={<MuhuratFinderPage />} />
        <Route path="/ishta-devata" element={<IshtaDevataPage />} />
        <Route path="/ashtakavarga" element={<AshtakavargaPage />} />
        <Route path="/rashi-tulya-navamsa" element={<RashiTulyaNavamsaPage />} />
        <Route path="/kalachakra-dasha" element={<KalachakraDashaPage />} />
        <Route path="/dasha" element={<DashaCalculatorPage />} />
        <Route path="/saptavimshamsha" element={<SaptavimshamshaPage />} />
        <Route path="/rudramsha" element={<RudramshaPage />} />
        <Route path="/wealth-hora" element={<WealthHoraPage />} />
        <Route path="/marriage-muhurat" element={<MarriageMuhuratPage />} />
        <Route path="/d2" element={<WealthHoraPage />} />
        <Route path="/tools" element={<AllToolsPage />} />
        <Route path="/celebrities" element={<CelebritiesPage />} />
        <Route path="/celebrities/:category" element={<CelebritiesPage />} />
        <Route path="/celebrities/:category/:slug" element={<CelebrityDetailPage />} />
        <Route path="/astro-gps" element={<AstroGPSPage />} />
        <Route path="/life-replay" element={<LifeReplayPage />} />
        <Route path="/wealth-programming" element={<WealthProgrammingPage />} />
        <Route path="/admin/astrologer-applications" element={<AdminAstrologerApplicationsPage />} />
        <Route path="/admin/astrologers" element={<AdminAstrologersPage />} />
        <Route path="/admin/recent-ratings" element={<AdminRecentRatingsPage />} />
        <Route path="/admin/customer-lookup" element={<AdminCustomerLookupPage />} />
        <Route path="/admin/current-vips" element={<AdminCurrentVipsPage />} />
        <Route path="/admin/lottery-dates" element={<AdminLotteryDatesPage />} />
        <Route path="/admin/karma-vipaka" element={<AdminKarmaVipakaPage />} />
        <Route path="/admin/wallet-deductions" element={<AdminWalletDeductionsPage />} />
        <Route path="/wallet/topup" element={<WalletTopUpAmountPage />} />
        <Route path="/wallet/topup/pay" element={<WalletTopUpPayPage />} />
        <Route path="/admin/llm-usage" element={<AdminLLMUsagePage />} />
        <Route path="/admin/whales" element={<AdminWhalesPage />} />
        <Route path="/admin/celebrity-cache" element={<AdminCelebrityCachePage />} />
        <Route path="/admin/add-celebrity" element={<AdminAddCelebrityPage />} />
        <Route path="/admin/delete-celebrity" element={<AdminDeleteCelebrityPage />} />
        <Route path="/tools/celebrity-lookalike" element={<CelebrityLookalikePage />} />
        <Route path="/tools/celebrity-pattern-recognizer" element={<CelebrityPatternRecognizerPage />} />
        <Route path="/tools/baby-muhurat" element={<BabyMuhuratPage />} />
        <Route path="/career-remedy" element={<CareerRemedyPage />} />
        <Route path="/bhagya-remedy" element={<BhagyaRemedyPage />} />
        <Route path="/d10-remedy" element={<D10RemedyPage />} />
        <Route path="/admin/ads-performance" element={<AdminAdsPerformancePage />} />
        <Route path="/admin/recent-purchases" element={<AdminRecentPurchasesPage />} />
        <Route path="/admin/recent-topups" element={<AdminRecentTopupsPage />} />
        <Route path="/blog" element={<BlogListPage />} />
        <Route path="/blog/:slug" element={<BlogPostPage />} />
        <Route path="/admin/blog" element={<AdminBlogPage />} />
        <Route path="/admin/autoblog" element={<AdminAutoBlogPage />} />
        <Route path="/contact" element={<ContactUsPage />} />
        <Route path="/admin/contact-queries" element={<AdminContactQueriesPage />} />
        <Route path="/admin/seed-reviews" element={<AdminSeedReviewsPage />} />
        <Route path="/admin/global-markets" element={<AdminGlobalMarketsPage />} />
        <Route path="/community" element={<CommunityHomePage />} />
        <Route path="/forum" element={<ForumPage />} />
        <Route path="/forum/post/:id" element={<ForumPostDetail />} />
        <Route path="/forum/tag/:tag" element={<ForumPage />} />
        <Route path="/admin/forum" element={<AdminForumPage />} />
        <Route path="/admin/library" element={<AdminLibraryPage />} />
        <Route path="/admin/nadi-astrology" element={<NadiAstrologyPage />} />
        <Route path="/auth/google" element={<GoogleAuthCallback />} />
        <Route path="/privacy" element={<PrivacyPolicyPage />} />
        <Route path="/terms" element={<TermsOfServicePage />} />
        <Route path="/refund" element={<RefundPolicyPage />} />
        <Route path="/refunds" element={<Navigate to="/refund" replace />} />
        <Route path="/cancellation-refund" element={<Navigate to="/refund" replace />} />
        <Route path="/shipping" element={<ShippingPolicyPage />} />
        <Route path="/shipping-exchange" element={<Navigate to="/shipping" replace />} />
        <Route path="/admin/users" element={<AdminUsersPage />} />
        <Route path="/admin/grant-unlock" element={<AdminGrantUnlockPage />} />
        <Route path="/admin/astrologer-visibility" element={<AdminAstrologerVisibilityPage />} />
        <Route path="/admin/promos" element={<AdminPromosPage />} />
        <Route path="/admin/account-delete" element={<AdminAccountDeletePage />} />
        <Route path="/admin/store-orders" element={<AdminStoreOrdersPage />} />
        <Route path="/admin/voice-calls" element={<AdminVoiceCallsPage />} />
        <Route path="/account-deletion" element={<AccountDeletionPage />} />
        <Route path="/admin/push" element={<AdminPushPage />} />
        <Route path="/super-admin/pdf-cache" element={<AdminPdfCachePurgePage />} />
        <Route path="/admin/themes" element={<AdminThemesPage />} />
        <Route path="/admin/withdrawals" element={<AdminWithdrawalsPage />} />
        <Route path="/course-booking" element={<CourseBookingPage />} />
        <Route path="/twenty-year-prediction" element={<TwentyYearPredictionPage />} />
        <Route path="/astro-visualization" element={<AstroVisualizationPage />} />
        <Route path="/showcase" element={<AppShowcasePage />} />
        <Route path="/visualise" element={<VisualiseIntroPage />} />
        <Route path="/personal-zoom-meeting" element={<PersonalZoomMeetingPage />} />
        {/* Removed tools — redirect to home for any stale links */}
        <Route path="/wealth-quotient" element={<Navigate to="/" replace />} />
      </Routes>
      <OnboardingGate />
      <OngoingChatDock />
      <GlobalAstrologerRing />
      {/* PlatformUpdateModal ("Two flagship tools just landed") permanently disabled per user request — Feb 2026 */}
      <PushPermissionModal />
      {/* Globally-mounted mobile tab bar. Renders on every route
          EXCEPT chat windows (self-hides via useLocation). Page
          authors no longer need to import/render the bar themselves. */}
      <GlobalMobileTabBar />
    </>
  );
}

function App() {
  return (
    <div className="App">
      <HelmetProvider>
        <BrowserRouter>
          <AuthProvider>
            <CurrencyProvider>
              <ThemeProvider>
                <OngoingChatProvider>
                  <CosmicNightBackdrop />
                  <AppRouter />
                  <Toaster
                    theme="light"
                    position="top-right"
                    toastOptions={TOAST_OPTIONS}
                    offset={TOAST_OFFSET}
                    mobileOffset={TOAST_OFFSET}
                  />
                </OngoingChatProvider>
              </ThemeProvider>
            </CurrencyProvider>
          </AuthProvider>
        </BrowserRouter>
      </HelmetProvider>
    </div>
  );
}

export default App;
